// ===========================================
// Possible duplicates (enquiries plan §7, Phase 2): WARN ONLY
// ===========================================
// Under the add form's contact fields: other enquiries with the same email or phone, and the
// family the email already belongs to. Nothing is refused or merged; staff decide.

import { Alert, AlertTitle, Box, Typography } from '@mui/material';
import type { EnquiryClientConfig, EnquiryMatches } from '../../../api/enquiry.api';
import { formatDay, stageLabel } from './enquiryUi';

interface DuplicateWarningProps {
  matches: EnquiryMatches | undefined;
  config: EnquiryClientConfig | undefined;
}

const MATCH_WORDS = { EMAIL: 'email', PHONE: 'phone' } as const;

export default function DuplicateWarning({ matches, config }: DuplicateWarningProps) {
  const enquiries = Array.isArray(matches?.enquiries) ? matches.enquiries : [];
  const families = Array.isArray(matches?.families) ? matches.families : [];
  if (enquiries.length === 0 && families.length === 0) return null;

  return (
    <Alert severity="warning" data-testid="duplicate-warning">
      <AlertTitle>Possible duplicate</AlertTitle>
      {families.length > 0 && (
        <Typography variant="body2" sx={{ mb: enquiries.length > 0 ? 1 : 0 }}>
          This email belongs to the {families.length === 1 ? 'family' : 'families'}{' '}
          <strong>{families.map((f) => f.name).join(', ')}</strong>.
        </Typography>
      )}
      {enquiries.length > 0 && (
        <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
          {enquiries.map((e) => (
            <li key={e.id}>
              <Typography variant="body2">
                {e.firstName} {e.lastName}, {stageLabel(config, e.stage)}
                {e.archived ? ' (archived)' : ''}, received {formatDay(e.receivedOn)}: same{' '}
                {e.matchedOn.map((m) => MATCH_WORDS[m]).join(' and ')}
              </Typography>
            </li>
          ))}
        </Box>
      )}
    </Alert>
  );
}
